import React from "react";
import PropTypes from "prop-types";

const Plus = ({ className, color }) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0979375 4.976H4.87394V0.0319996H6.72194V4.976H11.4979V6.728H6.72194V11.696H4.87394V6.728H0.0979375V4.976Z"
      fill={color}
    />
  </svg>
);

Plus.propTypes = {
  className: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  testId: PropTypes.string,
};

export default Plus;
